<template>
    <h2 class="sub-header" :id="slugify(content)" v-html="$t(content)"></h2>
</template>

<script>
import { slugify } from '@/mixins/helper';
export default {
    name: 'SubHeader',
    methods: { slugify },
    props: {
        content: String,
    },
};
</script>

<style scoped>
.sub-header {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 2px;
    margin-top: 4px;
    scroll-margin-top: 20px;
}
</style>
